import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropSeedingsByPrimaryDataId, setFootprintingCropSeedingsByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP, FOOTPRINTING_CROP_SEEDINGS } from "consts";

import { FootprintingCropSeeding } from "models";

export const useMutateFootprintingCropSeedings = (farmId: string, cropId: string, year: number, payload: FootprintingCropSeeding[], primaryDataId: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropSeedingsByPrimaryDataIdAdmin : setFootprintingCropSeedingsByPrimaryDataId;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_SEEDINGS, primaryDataId],
      mutationFn: () => queryFn(payload, primaryDataId ?? ""),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_CROP_SEEDINGS, primaryDataId],
          [FOOTPRINTING_CROP, farmId, cropId, year],
          [FOOTPRINTING_CROP, primaryDataId, isAdmin],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
